import React from 'react'
import Card from '../shared/card/card.jsx'
import root from '../shared/utils'
import {getUpSellIconType} from '../shared/enums/upsell-icon-type'

export default React.createClass({

  render: function () {
    let upSellType = getUpSellIconType(this.props.card.upSellType)

    let mediaServer = root + '/common/latest/images/consumer/'
    let backImage = mediaServer + upSellType.bgsrc
    let midIcon = upSellType.iconsrc
    let moduleType = this.props.card.moduleType

    let btnId = 'upsellCard'
    if(this.props.btnId) {
      btnId += this.props.btnId
    }

    return (
      <Card
        imageHeight='150px'
        headerTitle={this.props.card.header}
        cardClass={upSellType.iconsrc + '-background'}
        heroImage={backImage}
        btnOnClick={() => this.props.openModal(this.props.card)}
        tempHeight={this.props.tempHeight}
        headerMidIcon={midIcon}
        bodyText={this.props.card.content}
        moduleType={moduleType}
        btnText='More Details'
        padding={22}
        btnStyle='btn btn-sm btn-link'
        btnId={btnId}
        noPullDown={this.props.noPullDown}
        index={this.props.index}>
        <p dangerouslySetInnerHTML={{__html: this.props.card.content}}/>
      </Card>
    )
  }
})


// WEBPACK FOOTER //
// ./src/components/dashboard/up-sell-card.jsx